import {addEditBillingGroupActionTypes} from "../constants/AddEditActionConstants";
import authService from "../../../auth/AuthService";

const editSelectedBillingGroup = (billingGroupDetail) => ({
    type: addEditBillingGroupActionTypes.EDIT_ONE_BILLING_GROUP,
    payload: {billingGroupDetail}
});
const setBillingGroupForm = ({ name, value }) => ({
    type: addEditBillingGroupActionTypes.SETTING_BILLING_GROUP_FORM_OBJECT_VALUE,
    payload: { name, value },
});
const setBillingGroupFormDescription = ({ name, value, change_obj }) => ({
    type: addEditBillingGroupActionTypes.SETTING_BILLING_GROUP_FORM_DESCRIPTION,
    payload: { name, value },
});
const setBillingGroup = (bg, change_obj) => ({
    type: addEditBillingGroupActionTypes.SELECT_BILLING_GROUP,
    payload: {bg, change_obj}
})
const selectDropdowns = (option, change_obj) => ({
    type: addEditBillingGroupActionTypes.SET_BILLING_GROUP_DROPDOWNS,
    payload: {option, change_obj}
});
const toggleOptions = (option) => ({
    type: addEditBillingGroupActionTypes.SET_BILLING_GROUP_TOGGLES,
    payload: {option}
});
const selectDate = (day) => ({
    type: addEditBillingGroupActionTypes.SET_BILLING_GROUP_DATE,
    payload: {day}
});
const toggleModal = () => ({
    type:addEditBillingGroupActionTypes.TOGGLE_MODAL
});
const addBillingGroupModal = () => ({
    type: addEditBillingGroupActionTypes.ADD_BILLING_GROUP
});
const validateBillingGroup = (billingGroupObj, formSource, authToken) => ({
    type: addEditBillingGroupActionTypes.VALIDATE_BILLING_GROUP_FORM,
    payload: {billingGroupObj, formSource, authToken}
});
const updateBillingGroup = () => ({
    type: addEditBillingGroupActionTypes.UPDATED_BILLING_GROUP_REFRESH
});

export function editOneBillingGroup(billingGroupDetail) {
    return (dispatch) => {
        dispatch(editSelectedBillingGroup(billingGroupDetail));
    }
}

export function setBillingGroupFormValues({ name, value }) {
    return (dispatch) => {
        dispatch(setBillingGroupForm({ name, value }));
    }
}

export function setBillingGroupDescription({ name, value }) {
    return (dispatch) => {
        dispatch(setBillingGroupFormDescription({ name, value }));
    }
}

export function setBillingGroupFormDropdownValues(option, change_obj) {
    return (dispatch) => {
        dispatch(selectDropdowns(option, change_obj));
    }
}

export function setBillingGroupFormToggleValues(value) {
    return (dispatch) => {
        dispatch(toggleOptions(value));
    }
}

export function setBillingGroupFormDateValues({day}) {
    return (dispatch) => {
        dispatch(selectDate({day}));
    }
}

export function toggleBillingGroupModal() {
    return (dispatch) => {
        dispatch(toggleModal());
    }
}

export function addBillingGroup() {
    return (dispatch) => {
        dispatch(addBillingGroupModal());
    }
}

export function selectBillingGroup(bg, change_obj) {
    return (dispatch) => {
        dispatch(setBillingGroup(bg, change_obj))
    }
}

export function updatedBillingGroupRefresh() {
    return (dispatch) => {
        dispatch(updateBillingGroup());
    }
}

export function validateBillingGroupForm(billingGroupObj, formSource){
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(validateBillingGroup(billingGroupObj, formSource, authToken));
    }
}
